module.exports = function(num, delta) {
  return num + delta;
};